import axios from 'axios';

import routes from 'app/routes';

export default {
  block: (enterpriseId, values, errorCallback) => {
    axios
      .post(routes.api.enterprises.blocked(enterpriseId), values)
      .then(() => {
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  unlock: (enterpriseId, callback) => {
    axios
      .put(routes.api.enterprises.unlock(enterpriseId))
      .then(() => {
        callback();
      });
  },

};
